/* eslint-disable no-use-before-define */
import React from 'react'
import CriteriaCustom from './custom-search'
import CriteriaHolding from './holding-search'
import useMarketNews from './use-market-news'

export default () => {

    const { isModal, tab, setTab } = useMarketNews()

    return <React.Fragment>
    <div
        data-name="municipals-market-news-nav-tabs"
        className="nav-tabs">
    <ul>
        <li className={tab==='CUSTOM' ? 'active' : ''}>
        <button
            data-name="municipals-market-news-custom-search-nav-tab"
            onClick={() => setTab('CUSTOM')}>Custom Search</button>
        </li>

        <li className={tab==='HOLDING' ? 'active' : ''}>
        <button
            data-name="municipals-market-news-holding-search-nav-tab"
            onClick={() => setTab('HOLDING')}>Holdings Search</button>
        </li>
    </ul>
    </div>

    {tab==='CUSTOM' && <CriteriaCustom isModal={isModal} />}
    {tab==='HOLDING' && <CriteriaHolding />}
    </React.Fragment>
}
